module.exports = __webpack_public_path__ + "static/media/login-backage.0e64f0c0.png";